export default "__VITE_ASSET__oCcDcsIp__"